'use strict';

export default function routes($stateProvider) {
  'ngInject';
  $stateProvider.state('site', {
    url: '/site/:id',
    template: '<site></site>',
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/site/site.routes.js